export default __webpack_public_path__ + "static/background-2-26b2a200410c1eb42daee5f50a30441d.svg";